var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/alert/warning_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/alert/warning_24px_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5301 20.5037C21.0701 20.5037 22.0301 18.8337 21.2601 17.5037L13.7301 4.49372C12.9601 3.16372 11.0401 3.16372 10.2701 4.49372L2.74012 17.5037C1.97012 18.8337 2.93012 20.5037 4.47012 20.5037H19.5301ZM12.0001 13.5037C11.4501 13.5037 11.0001 13.0537 11.0001 12.5037V10.5037C11.0001 9.95372 11.4501 9.50372 12.0001 9.50372C12.5501 9.50372 13.0001 9.95372 13.0001 10.5037V12.5037C13.0001 13.0537 12.5501 13.5037 12.0001 13.5037ZM11.0001 15.5037V17.5037H13.0001V15.5037H11.0001Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.705f1c46574377a53c32b78c8eed7f08.svg";
export { ForwardRef as ReactComponent };